const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    header: () =>
        __('Nyheder'),

    writeHeader: () =>
        __('Skriv nyhed'),
    writeExplain: () =>
        __('Vi anbefaler, at du skriver en kort nyhed og eventuelt linker til en større artikel eller lignende. Vi anbefaler også, at du uploader et billede, som kan bruges sammen med artiklen.'),
    writeFrequency: () =>
        __('Vi udsender dagligt nyhederne på e-mail. Alle dine følgere vil modtage det, du skriver'),
    linkToCreateNewsletter: () =>
        __('Gå til opret nyhed'),
};
